/**
 * 一括マスク解除（POST commercial-reception-book/mask-unlock）で
 * 1リクエストあたりに指定できる商業登記受付帳IDの上限数。
 *
 * バックエンド（lakers-backend）の
 * `lakers_backend/api/commercial_reception_book/serializers.py` にある
 * `MASK_UNLOCK_MAX_IDS` と必ず同じ値にすること。
 * 片方だけ変更すると「フロントでは選択できたのにAPIで弾かれる」
 * 「フロントで弾いているのにAPIはもっと許容できる」という乖離が発生するため、
 * 値を変える場合は両リポジトリで揃えて修正すること。
 */
export const MASK_UNLOCK_MAX_IDS = 1000;
